export interface DeepStringMap {
  [key: string]: DeepStringMap | string;
}

export function transformStringMapValuesToPaths<T extends DeepStringMap>(
  obj: T,
  prependingPath = '',
): T {
  const result: DeepStringMap = {};

  for (const key of Object.keys(obj)) {
    const currentPath = `${prependingPath}${key}`;

    if (typeof obj[key] === 'string') {
      result[key] = currentPath;
    } else {
      result[key] = transformStringMapValuesToPaths(obj[key], `${currentPath}.`);
    }
  }

  return result as T;
}
